import ConcentratesSiloIcon from './concentrates-silo-icon';
export default ConcentratesSiloIcon;
